/**
* 头部菜单
*/ 
<template>
  <el-menu
    class="el-menu-demo"
    mode="horizontal"
    background-color="#fff"
    text-color="#fff"
    active-text-color="#fff"
  >
    <div class="content">
      <div class="title_text"><el-link :href="href">进入官网</el-link></div>
      <div class="title_text"><el-link>进入商城</el-link></div>
      <div class="title_text">
        <el-link href="https://www.everfast.ca/">进入极速快递</el-link>
      </div>
      <div class="user_info">
        <img
          :src="userInfo.avatar ? userInfo.avatar : inmg"
          class="user_img"
          alt=""
        />
        <!-- <img :src="@/assets/img/user.png" class="user_img" alt="" /> -->
        <div class="title_texts">
          <el-link
            :underline="false"
            href="/userInfo/userInfo"
            type="primary"
            style="text-decoration: underline"
            >{{
              userInfo.orderstartnumber
                ? userInfo.orderstartnumber
                : userInfo.realName
            }}</el-link
          >
          <span style="margin-left: 10px"> 已登录</span>
        </div>
        <el-button type="primary" @click="exit" plain style="margin-left: 23px"
          >退出登录</el-button
        >
      </div>
    </div>
  </el-menu>
</template>
<script>
import { loginout } from "../api/userMG";
import Cookies from "js-cookie";
import inmg from "@/assets/img/user.png";
import crudDept from "@/api/userMG";
import { getToken } from "@/utils/auth";
export default {
  name: "navcon",
  data() {
    return {
      inmg,
      userInfo: "",
      // useriMG:img,
      collapsed: true,
      logistics_user: "",
      user: {},
      token: false,
      href: "",
    };
  },
  // 创建完毕状态(里面是操作)
  created() {
    if (typeof Cookies.get("logistics_user") == "string") {
      this.logistics_user = JSON.parse(Cookies.get("logistics_user"));
    } else {
      this.logistics_user = Cookies.get("logistics_user");
    }
    if (getToken()) {
      this.href =
        "https://epluscanada.com/dashboard?token=" +
        getToken() +
        "&id=" +
        this.logistics_user.id;
    } else {
      this.href = "https://epluscanada.com/dashboard";
    }

    this.users();
  },
  methods: {
    users() {
      if (typeof Cookies.get("logistics_user") == "string") {
        var logistics_user = JSON.parse(Cookies.get("logistics_user"));
      } else {
        var logistics_user = Cookies.get("logistics_user");
      }
      var data = {
        id: logistics_user.id,
      };
      crudDept.user(data).then((res) => {
        this.userInfo = res.content[0];
      });
    },
    logout() {
     crudDept.logout().then(() => {
        window.location.href =
          "https://adminportal.shuyu-global.com/login?login=1&jumpLogin=1";
        this.$message({
          type: "success",
          message: "已退出登录!",
        });
        Cookies.remove("logistics_user");
        Cookies.remove("logistics_accessToken");
        Cookies.remove("logistics_refreshToken");
        // location.reload()
      });
    },
    // 退出登录
    exit() {
      this.$confirm("退出登录, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          setTimeout(() => {
            this.$store.commit("logout", "false");
            this.logout();

            // this.$router.push({ path: "/login" });
          }, 1000);
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    // 切换显示
    toggle(showtype) {
      this.collapsed = !showtype;
      this.$root.Bus.$emit("toggle", this.collapsed);
    },
  },
};
</script>
<style scoped>
.el-menu-vertical-demo:not(.el-menu--collapse) {
  border: none;
}
.submenu {
  float: right;
}
.buttonimg {
  height: 60px;
  background-color: transparent;
  border: none;
}
.showimg {
  width: 26px;
  height: 26px;
  position: absolute;
  top: 17px;
  left: 17px;
}
.showimg:active {
  border: none;
}
.content {
  height: 60px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding-right: 90px;
  box-sizing: border-box;
}
.title_text {
  font-size: 15px;
  margin-right: 50px;
  color: #333;
}
.user_info {
  display: flex;
  align-items: center;
  justify-content: center;
}
.user_img {
  width: 35px;
  height: 35px;
  border-radius: 50%;
  margin-right: 10px;
}
.title_texts {
  font-size: 14px;
  color: #333;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>


// WEBPACK FOOTER //
// src/components/navcon.vue